/* eslint-disable max-lines */
/* eslint-disable max-len */
/* eslint-disable max-lines-per-function */
import { Col, Row, Typography } from "antd";
import { IPerlickChOrderDetailsResponse } from "interfaces/ClientInterface/PerlickClientInterface/ICHOrder";
import React from "react";

const { Text } = Typography;

interface PerlickCHDetailsCardProps {
  chOrderData: IPerlickChOrderDetailsResponse;
}

const PerlickCHDetailsCard: React.FC<PerlickCHDetailsCardProps> = ({ chOrderData }) => {
  return (
    <Row gutter={[16, 16]} className="order-details">
      <Col xs={24} md={12}>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>System ID:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.Sysid}</Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Rep:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.Rep}</Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Quote Number:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.Quote || "-"}</Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Customer:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.SoldTo}</Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Customer Name:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.Soldtoname}</Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>No. of trunk housings:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.Notrunks}</Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Allow Manifolding:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.Manifold}</Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Altitude (ft):</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.Altitude}</Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Dimension Status:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.DimStatus}</Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Cooler Temperature:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.CoolerTemp}</Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Carbonation Level:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.Carbonation}</Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Order Number:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.OrdNo || "-"}</Text>
          </Col>{" "}
          {/* static */}
        </Row>
      </Col>

      <Col xs={24} md={12}>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Job Name:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.Jobname}</Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Address Line 1:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.JobAdd1}</Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Address Line 2:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.JobAdd2 || "-"}</Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>City, State, Zip:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">
              {`${chOrderData?.Jobcity}, ${chOrderData?.Jobstate} ${chOrderData?.JobZip}`}
            </Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Contact Name:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.JobContact || "-"}</Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Contact Phone:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.JobContactPhone || "-"}</Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Contact Fax:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.JobContactFax || "-"}</Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Approx. Install Date:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.InstallDate}</Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Customer P.O. No.:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.PoNum || "-"}</Text>
          </Col>{" "}
          {/* static */}
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Installer ID:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.InstallerId || "-"}</Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Customer Price:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.InstallCustPrice}</Text>
          </Col>
        </Row>
        <Row className="my-2">
          <Col span={10}>
            <Text className="font-12">
              <b>Contract Price:</b>
            </Text>
          </Col>
          <Col span={14}>
            <Text className="font-12">{chOrderData?.InstallContPrice}</Text>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};

export default PerlickCHDetailsCard;
